import { IValidationMessage } from "../types";

export type Validator<T, TRoot = any> = (value: T, root: TRoot) => IValidationMessage;

export class ValidateAny<T = any, TRoot = any> {
    protected readonly name;
    protected readonly key: string;
    private readonly rules: Validator<T>[];
    protected isRequired: boolean;

    constructor(name: string, key: string) {
        this.name = name;
        this.key = key;
        this.rules = [];
    }

    protected add(rule: Validator<T>) {
        this.rules.push(rule);
    }
    protected parse(value: string): T {
        return value as any;
    }
    
    public required(condition?: (root: TRoot) => boolean, defaultValue?: any) {
        this.isRequired = true;

        this.add((value: any, root: TRoot) => {
          // Basic types:
          if (
            ((typeof value === "string" || typeof value === "number") &&
              value &&
              value !== defaultValue) ||
            (typeof value === "boolean" && (value || value === false))
          ) {
            return null;
          }
          // Objects (being not null, undefined)
          if (typeof value === "object" && value) {
            if (typeof value.length === "number" && value.length > 0)
              return null;
          }
          if (condition && !condition(root)) {
            return null;
          }
          // TODO(sst): Investigate if we can check field.id === "sym_organizationtypeother", in that case we should change the label to "Indien u hebt gekozen voor anders, vul dan hier a.u.b. het type in, zo niet, dan volstaat een -"
          return { message: `${this.name} is verplicht` };
        });
        return this;
    }
    public sameAs(other: (root: TRoot) => T, message: string) {
        this.add((value: any, root: TRoot) => {
            if (value === other(root))
                return null;

            return { message: `${this.name} ${message}` };
        });
        return this;
    }
    public custom(valid: (value: T, root: TRoot) => boolean, message: string) {
        this.add((value: any, root: TRoot) => {
            if (valid(value, root))
                return null;

            return { message: this.name ? `${this.name} ${message}` : message };
        });
        return this;
    }

    public build(): { validator: Validator<T>, required: boolean } {
        return {
            required: this.isRequired,
            validator: (value: any, root: TRoot) => {
                value = this.parse(value);

                for (const validate of this.rules) {
                    const result = validate(value, root);

                    if (result)
                        return result;
                }

                return null;
            }
        };
    }
}

